(function () {
    'use strict';

    angular.module("imApp").factory("vatReportsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3128,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
